module.exports = __webpack_public_path__ + "static/img/jingmen.8cbc065.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jingmen.png
// module id = RaOw
// module chunks = 1